<template>
    <!--Client Waiting List Page-->
    <div class="client-step1">
        <!--Step One-->
        <div class="client-step1-wrap section-wrap">
            <!--Subtitle-->
            <h5>
                {{ $ml.get("waitingList.title") }} - {{ currentWaitingListStylist.first_name }},
                {{ currentWaitingListStylist.last_name }}
            </h5>
            <div class="step1-content" v-if="!loading">
                <p class="highlight-text">{{ $ml.get("waitingListClient.stepOne") }}</p>
                <p>
                    To get notified when a spot opens up, please select your preferred notification method below.
                    Notifications will come from our <span v-if="generalOptions.app_id === 1">Ring My Stylist</span>
                    <span v-if="generalOptions.app_id === 2">Ring My Barber</span>
                    <span v-if="generalOptions.app_id === 5">Ring My Loctician</span> account, and we need your consent
                    to proceed.
                </p>
                <!--Radio inputs-->
                <fieldset class="client-radio-inputs">
                    <!--Text Message-->
                    <div class="radio-input" v-if="notificationMethods.sms">
                        <input
                            type="radio"
                            id="text-message"
                            name="notificationMethod"
                            value="sms"
                            v-model="notificationMethod"
                        />
                        <label for="text-message">
                            <span>{{ $ml.get("waitingListClient.textMessage") }}</span>
                            {{ $ml.get("waitingListClient.textMessageParagraph") }}
                        </label>
                    </div>
                    <!--Email Message-->
                    <div class="radio-input" v-if="notificationMethods.email">
                        <input
                            type="radio"
                            id="email-message"
                            name="notificationMethod"
                            value="email"
                            v-model="notificationMethod"
                        />
                        <label for="email-message">
                            <span>{{ $ml.get("waitingListClient.emailMessage") }}</span>
                            {{ $ml.get("waitingListClient.emailMessageParagraph") }}
                        </label>
                    </div>
                    <!--App Notification-->
                    <div class="radio-input" v-if="notificationMethods.push">
                        <input
                            type="radio"
                            id="app-notification"
                            name="notificationMethod"
                            value="push"
                            v-model="notificationMethod"
                        />
                        <label for="app-notification">
                            <span>{{ $ml.get("waitingListClient.appNotification") }}</span>
                            {{ $ml.get("waitingListClient.appNotificationParagraph") }}
                        </label>
                    </div>
                </fieldset>
                <p class="text-error" v-if="notificationMethod == ''">
                    {{ $ml.get("waitingList.note") }} {{ $ml.get("waitingList.textError") }}
                </p>
                <div class="next-btn">
                    <button
                        type="button"
                        class="primary-btn extra-small mobile"
                        :disabled="notificationMethod === ''"
                        :class="notificationMethod === '' ? 'disabled-button' : ''"
                        @click="handleSaveClientWaitlistSettings"
                    >
                        {{ $ml.get("general.saveContinue") }}
                    </button>
                    <button type="button" class="secondary-btn small mobile" @click="changeSection('client-wlist')">
                        {{ $ml.get("general.goBack") }}
                    </button>
                </div>
                <span class="main-text-link" @click="handleSaveForLater">{{ $ml.get("general.saveLater") }}</span>
            </div>
            <main-loader v-if="loading"></main-loader>
        </div>
    </div>
</template>

<script>
import store from "../../../../../services/vuex";
import api from "../../../../../services/api_endpoints";
import messages from "../../../../../services/messages";
import MainLoader from "../../../general-components/main_loader.vue";

export default {
    props: {
        client: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            notificationMethod: "",
            loading: false,
            notificationMethods: {
                email: 0,
                push: 0,
                sms: 0,
            },
        };
    },
    computed: {
        currentWaitingListStylist: {
            get: function () {
                return store.state.currentWaitingListStylist;
            },
            set: function (value) {
                store.commit("setCurrentWaitingListStylist", value);
            },
        },
    },
    mounted() {
        this.getClientWaitlistSettings(this.currentWaitingListStylist.id);
    },
    components: { MainLoader },
    methods: {
        changeSection(section) {
            this.$emit("change-section", section);
        },
        handleSaveClientWaitlistSettings() {
            this.changeSection("client-step2");
            this.saveClientWaitlistSettings();
        },
        saveClientWaitlistSettings() {
            if (this.notificationMethod === "") {
                return;
            }

            let data = {
                stylist_id: this.currentWaitingListStylist.id,
                notification_method: this.notificationMethod,
            };

            this.$http.post(api.actions.save_client_waitlist_settings, data).then((response) => {
                if (response.data.error == true) {
                    return;
                }

                this.getClientWaitlistSettings(this.currentWaitingListStylist.id);
                messages.successMessage(messages.GLOBAL_MESSAGES.WAITING_LIST_NOTIFICATION_PREFERENCE);
            });
            return;
        },
        getClientWaitlistSettings(stylistId) {
            this.loading = true;

            this.$http.get(api.actions.get_client_waitlist_settings + "/" + stylistId).then(
                function (response) {
                    if (response.data.error == true) {
                        return;
                    }

                    this.notificationMethods.sms = response.data.stylist_settings.sms;
                    this.notificationMethods.email = response.data.stylist_settings.email;
                    this.notificationMethods.push = response.data.stylist_settings.push;

                    if (response.data.settings.notification_method != undefined) {
                        this.notificationMethod = response.data.settings.notification_method;
                    } else {
                        this.notificationMethod = "";
                    }

                    this.loading = false;
                }.bind(this)
            );
        },
        handleSaveForLater() {
            if (this.notificationMethod === "") {
                return;
            }

            this.saveClientWaitlistSettings();
            this.changeSection("client-wlist");
        },
    },
};
</script>
